import React from 'react';
import c from 'classnames';
import { List } from 'immutable';
import { Paragraph } from '@uncinc/react-drupal-core';

import { FormattedLink, Button } from '../../../components';

import './style.scss';

const ParagraphLinkList = ({ entity, className }) => {
  const title = entity.getIn(['field_title', 0, 'value']);
  const paragraphRefs = entity.get('field_links_paragraphs', List());
  const simpleLinks = entity.get('field_link', List());

  if (paragraphRefs.isEmpty() && simpleLinks.isEmpty()) {
    return null;
  }

  return (
    <div className={`Paragraph paragraphLinkList row ${className}`}>
      <div class="col-md-6 col-lg-5">
        {title && <h2>{title}</h2>}
      </div>

      <div class="col-md-6 offset-lg-1 d-flex flex-column">
        {!paragraphRefs.isEmpty() && paragraphRefs.map((paragraphRef) => {
          const nestedEntity = paragraphRef.get('entity');
          const id = paragraphRef.get('target_id');

          return (
            <Paragraph
              key={`paragraph:${id}`}
              id={id}
              entity={nestedEntity}
            />
          );
        })}

       {!simpleLinks.isEmpty() && simpleLinks.map((linkField) => {
          const href = linkField.get('alias') || linkField.get('uri');
          const linkTitle = linkField.get('title');

          return (
            <Button
              key={href}
              href={href}
              type="secondary"
            >
              {linkTitle}
            </Button>
          );
        })}
      </div>
    </div>
  );
};

export default ParagraphLinkList;